module.exports = __webpack_public_path__ + "static/media/department.337ef689.png";